export const columnWidths: Record<string, number> = {
    duration: 100,
    version: 100,
    version_status: 200,
};
